module.exports = __webpack_public_path__ + "static/media/main_skybox_LF.730b1608.png";